import httpClient from '../axios/interceptors'
import { API } from "./endpoint"
import { AxiosResponse } from "axios"
import {
  ResponseGetFactoryById,
  ResponseGetFactoryDataNonAuthen,
  RequestCreateFactoryTaxInvoice,
  RequestUpdateFactoryTaxInvoice,
  ResponseFactoryTaxInvoice,
} from "./interface"
import { handleResponseError } from "helpers/utils"


export const getFactoryDataById = async (
    factoryId: string
  ): Promise<ResponseGetFactoryById> => {
    const data: AxiosResponse<ResponseGetFactoryById> = await httpClient
      .get(API.getFactoryDataById + factoryId)
      .catch((error) => handleResponseError(error))

    return data.data
  }

  //factory/get_data_nonauthen
  export const getFactoryDataNonAuthen = async (): Promise<ResponseGetFactoryDataNonAuthen> => {
    const data: AxiosResponse<ResponseGetFactoryDataNonAuthen> = await httpClient
      .get(API.getFactoryDataNonAuthen)
      .catch((error) => handleResponseError(error))

    return data.data
  }

  export const createFactoryTaxInvoice = async (
    body: RequestCreateFactoryTaxInvoice
  ): Promise<ResponseFactoryTaxInvoice> => {
    const data: AxiosResponse<ResponseFactoryTaxInvoice> = await httpClient
      .post(API.createFactoryTaxInvoice, body)
      .catch((error) => handleResponseError(error))
    return data.data
  }

  export const updateFactoryTaxInvoice = async (
    body: RequestUpdateFactoryTaxInvoice
  ): Promise<ResponseFactoryTaxInvoice> => {
    const data: AxiosResponse<ResponseFactoryTaxInvoice> = await httpClient
      .post(API.updateFactoryTaxInvoice, body)
      .catch((error) => handleResponseError(error))
    return data.data
  }
